import { I18nMessages } from "@joyz/app-core/plugins/jz-i18n";

export const jaTos: I18nMessages = {
  "tos.title": "利用規約",

  "tos.art1.title": "第１条（本利用規約）",
  "tos.art1.content":
    "本利用規約は、ジョイズ株式会社（以下「弊社」といいます。）が運営する英語学習アプリケーション「TerraTalk」で提供するサービス（以下「本サービス」といいます。）において基本となる利用条件を定めるものです。",

  "tos.art2.title": "第２条（本利用規約の適用）",
  "tos.art2.content": `「TerraTalk利用規約」（以下「本利用規約」といいます。）は、本サービスをご利用になるすべての方（以下「ユーザー」といいます。）に適用されるものとし、ユーザーは、本利用規約に同意の上、本サービスを利用するものとします。
２  本サービスの利用に関するヘルプ・利用ガイド・注意事項等は、本利用規約の一部を構成するものとします。
３  弊社は、ユーザーが「TerraTalk」のアプリケーションソフトをインストールまたは本サービスを利用することをもって本利用規約に同意したものとみなします。
４  本サービスのバージョンアップ版についても本利用規約が適用されます。`,

  "tos.art3.title": "第３条（通知方法）",
  "tos.art3.content": `弊社からユーザーへの通知は、通知内容を電子メール・本サービスへの掲載・書面等の弊社が適当と判断する方法により行います。
２  前項の規定に基づき、弊社からユーザーへの通知を電子メールの送信又は本サービスへの掲載の方法により行う場合、ユーザーに対する当該通知は、それぞれ電子メールの送信又は本サービスへの掲載がなされた時点から効力を生じるものとみなします。`,

  "tos.art4.title": "第４条（サービス内容の変更に対する事前承認）",
  "tos.art4.content":
    "ユーザーは、本サービスの全部または一部が有料化された場合には、本サービス内で弊社が提供する有料サービス（以下「有料サービス」といいます。）の申込をしなければ、本サービスの全部または一部が使用できなくなる場合があることをあらかじめ承認したものとみなします。",

  "tos.art5.title": "第５条（会員登録）",
  "tos.art5.content": `ユーザーは、本サービスのうち、会員登録を行ったユーザー（以下「会員」といいます。）の利用を希望する場合には、弊社所定の手続により所定の情報を登録することで、会員登録（以下「会員登録」といいます。）を行い、会員に限定して弊社より提供されるサービス（以下「会員サービス」といいます。）の利用に必要なIDおよびパスワード（以下「ユーザーアカウント」といいます。）を取得するものとします。
２  会員登録は弊社がこれを承認した場合に完了するものとし、会員登録が完了した場合、弊社は当該ユーザーに対し、ユーザーアカウントを付与するものとします。
３  ユーザーは、会員登録の際に入力または提供した情報（以下「登録情報」といいます。）の内容につき、自ら責任を負うものとします。
４  弊社は、登録情報が誤っている場合など、弊社が適当でないと判断したときは、会員サービスの提供を行わない場合があります。`,

  "tos.art6.title": "第６条（ＩＤ及びパスワード管理）",
  "tos.art6.content": `会員は、ユーザーアカウントを管理する責任を負うものとします。
２  弊社が発行したユーザーアカウントは、当該ユーザーアカウントの発行を受けた特定の会員のみが利用可能なものとし、第三者への譲渡、貸与を禁止します。
３  会員は、登録したユーザーアカウントにおいて発生するいかなる活動や行為についても、弊社に対して責任を負うことに同意するものとします。
４  会員は、ユーザーアカウントの不正利用の疑いがある場合には、速やかに弊社宛にご連絡ください。`,

  "tos.art7.title": "第７条 （有料サービスの申し込みおよび利用料）",
  "tos.art7.content": `会員は、有料サービスの利用を希望する場合には、有料サービスの仕組みおよび有料サービスの内容を理解・承諾の上、弊社指定の申込フォームにより、弊社の指定する情報を登録することで申し込みを行うものとします。
２  会員が前項の申し込みをし、弊社が承諾の意思表示をした場合に、有料サービスにかかる個別契約が成立するものとします。
３  会員は、有料サービス利用の対価として、弊社が指定する方法により、弊社が別途定める金額（以下「利用料」といいます。）を支払うものとします。
４  会員は、利用料の支払いが完了したと弊社が認めた日（以下、「利用開始日」といいます。）から、有料サービスの利用が可能になるものとします。なお、弊社による利用料の支払確認に伴い、会員の利用開始日が遅くなった場合であっても、弊社はそれによる返金、利用可能期間の延長、その他一切の補填などを行う責任を負わないものとし、会員は、これをあらかじめ承諾するものとします。
５  会員は、本サービスが終了した場合においても、本サービス終了までに使用した有料サービスの利用料全額の支払義務を負うものとします。`,

  "tos.art8.title": "第８条（退会）",
  "tos.art8.content": `会員が退会を希望する場合、会員は弊社所定の方法により退会の手続を行うものとします。
２  会員が前項の解約をした場合、弊社は弊社の裁量で会員サービスにおいて登録または利用した情報を削除できるものとし、会員はこれに異議を申し出ることはできません。
３  弊社は、会員が次の各号のいずれか一つに該当する場合、弊社の判断により強制的に退会いただきます。 
①  会員が有料サービスを利用し、利用料を所定の期日までに支払わないとき
②  弊社の定める方法によらず会員登録を行ったことが明らかとなった場合 
③  その他弊社が不適切と判断した場合
４  退会時に会員が有料サービス未決済その他弊社に対する負債及び義務があるときは、会員はこれらの支払その他の義務を退会後も引き続き負うものとします。`,

  "tos.art9.title": "第９条（本サービスの利用）",
  "tos.art9.content": `ユーザーは、本サービスを利用するにあたって必要な通信端末および通信機器等の通信環境を自らの費用と責任において整えるものとします。また、本サービスの利用にあたって必要な通信費用等はユーザーが負担するものとします。
２  ユーザーは、本サービスで提供される言語学習に際して、本サービスの人工知能システムがユーザーの会話内容等を記憶する場合があることを了承し、ユーザーは本サービスにおける言語学習の際に、個人情報（氏名、住所、電話番号、メールアドレス、生年月日、所属する会社名・団体名、役職、金融機関口座番号、クレジットカード番号、その他の情報等でそのうち1つもしくは2つ以上を組み合わせることによって特定の個人を識別できるもの）を含む会話等をおこなわないように注意して本サービスを利用するものとします。
３  ユーザーが、前項に違反した結果、人工知能システムが個人情報を取得した場合については、弊社が別途定めるプライバシーポリシーは適用されません。`,

  "tos.art10.title": "第10条（ユーザーの禁止行為）",
  "tos.art10.content": `ユーザーは、本サービスを利用するに際し、以下の行為を行ってはなりません。
① 本サービスを不正の目的をもって利用する行為
② 知的財産権、肖像権、パブリシティ権その他の権利を侵害する行為
③ プライバシーを侵害する行為
④ 名誉毀損行為、侮辱行為や他者の業務妨害となる行為
⑤ 詐欺等の犯罪に結びつく行為
⑥ 不正アクセス行為の防止等に関する法律に違反する行為、電子計算機損壊等業務妨害罪（刑法第234条の2）に該当する行為をはじめ、弊社及び他人のコンューターに対して不正な操作を行う行為
⑦ コンピュータウイルスなど有害なプログラム等を送信もしくは提供する行為、または推奨する行為
⑧ その他の犯罪行為又は法令等に違反する一切の行為
⑨ 弊社、ユーザーその他の第三者の情報を改ざん、消去する行為
⑩ 弊社、ユーザーその他の第三者の設備を不正に利用し、その運営に支障を与える行為
⑪ 弊社の承認を得ないで行う当ユーザーの身分を利用した全ての営業行為
⑫ 法令、利用規約等または公序良俗に違反する行為
⑬ 本サービスの運営を妨害する行為、或いは弊社の信頼を毀損するような行為
⑭ その他弊社が不適当と判断する行為
２  ユーザーが利用規約等に違反することにより、弊社が何らかの損害を被った場合、弊社はユーザーに対して損害の賠償請求ができるものとします。
３  弊社は、ユーザーが第１項に掲げる行為を行ったと合理的に判断した場合、事前に通知することなく、本サービスの利用を停止することができるものとします。`,

  "tos.art11.title": "第11条（資格の停止等）",
  "tos.art11.content": `弊社は、ユーザーが本利用規約に違反したと判断した場合、当該ユーザーに対し事前に通知することなく、当該ユーザーに対する本サービスの全部または一部の利用の一時停止、将来に渡った利用乃至は会員登録の禁止等、弊社が適切と判断した措置を行うことができるものとします。
２  弊社は、会員が一定期間以上本サービスを利用しない場合、または弊社が必要と認めた場合には、会員資格を停止することがあります。`,

  "tos.art12.title": "第12条（外部委託）",
  "tos.art12.content":
    "　弊社は、システム管理及びクレジット決済代行その他、必要に応じて業務の全部または一部を外部委託することができるものとします。",

  "tos.art13.title": "第13条（本サービスの変更および中止）",
  "tos.art13.content":
    "弊社は、本サービスの適切な運営を目的とする場合において、ユーザーにあらかじめ通知することなく本サービスの内容や仕様の変更、提供の停止または中止等の必要な措置をとることができます。弊社は、変更または停止、中止等によりユーザーに損害または不利益が生じたとしても、一切責任を負いません。",

  "tos.art14.title": "第14条（知的財産権）",
  "tos.art14.content": `  本サービスにおいて、ユーザーは、弊社が提供するコンテンツに関する全ての知的財産権及びそこから得られる利益を弊社が所有することについて同意するものとします。
２  ユーザーは、本サービスおよび本サービスに関連して発生する著作物、システム等についての著作権その他の知的財産権は、弊社または弊社に使用許諾を行った第三者に帰属するものであることを確認し、いかなる目的であれ転載、複製、送信、翻訳・翻案、改変・追加等の一切の使用行為を行わないものとします。
３  ユーザーが前項に違反して紛争が生じた場合、ユーザーは、自己の費用と責任において、当該紛争を解決するとともに、弊社および第三者に一切の損害を与えないものとします。`,

  "tos.art15.title": "第15条（非保証）",
  "tos.art15.content": `弊社は、次の各号について一切の保証を行いません。
①  本サービス利用に起因してユーザーのスマートフォン等に不具合や障害が生じないこと
②  本サービスが提供する情報等の正確性及び完全性
③  コンテンツが第三者の権利を侵害していないこと
④  本サービスが永続すること
⑤  本サービスの信頼性または効能等を保証すること
⑥  本サービスの利用がユーザーに必要な事項を満たすこと
⑦  本サービスの利用に中断またはエラーが発生しないこと
⑧  本サービスを通じて入手できる情報等がユーザーの期待を満たすものであること`,

  "tos.art16.title": "第16条（免責）",
  "tos.art16.content": `弊社は、ユーザーのスマートフォン端末・タブレット端末・ＰＣ等の利用環境について一切関与せず、また一切の責任を負いません。
２  弊社は、ユーザーが使用する機器、設備またはソフトウェアが本サービスの利用に適さない場合であっても、本サービスの変更、改変等を行う義務を負わないものとします。
３  弊社は、本サービスの内容変更、中断、終了によって生じたいかなる損害についても、一切責任を負いません。
４  弊社は、予期せぬ要因で本サービスの閲覧に関して障害が生じた場合、一切責任を負いません。 
５  弊社は、本サービスで提供される言語学習の内容について、チェック、保存の義務を負いません。
６  弊社は、本サービスで提供される言語学習の信頼性、正確性について責任を負いません。
７  弊社は、広告掲載企業・決済代行会社に関する事項につき、一切の責任を負いません。
８  弊社は、本サービスの各ページからリンクしているホームページに関して、合法性、道徳性、信頼性、正確性について一切の責任を負いません。
９  弊社は、本サービスのバージョンアップ版を提供する義務、および本サービスに関するサポートを行う義務を負いません。
10  弊社は、アクセス過多、その他予期せぬ要因に基づく本サービスの表示速度の低下や障害等によって生じたいかなる損害についても、一切責任を負いません。
11  理由の如何を問わずユーザーが本サービスの利用ができなくなったことによって、ユーザーに何らかの損害が発生した場合も、弊社は一切責任を負わないものとします。
12  ユーザーアカウントの第三者による盗用に伴う損害の発生について弊社は一切の責任を負いません。`,

  "tos.art17.title": "第17条（本サービスの中止等） ",
  "tos.art17.content": `弊社は、ユーザーにおいて、次の各号のいずれか一つに該当する事由が生じたときは、ユーザーに通知することなく本サービスを直ちに中止またはその利用を制限し、または会員資格を抹消することができるものとします。
①  差押え、仮差押え、仮処分、租税滞納処分、その他公権力の処分を受け、または会社更生手続及び民事再生手続の開始、破産もしくは競売を申し立てられ、または自ら会社更生手続、民事再生手続の開始もしくは破産申立てをしたときまたは第三者からこれらの申立てがなされたとき
②  資本減少、営業の廃止もしくは変更、または解散の決議をしたとき
③  公租公課の滞納処分を受けたとき
④  ユーザーの本サービス利用により、コンピュータウイルスや大量送信メールの拡散など、弊社または第三者に被害が及ぶおそれがあると弊社が判断した場合 
⑤  弊社がユーザーと電子メールによる連絡が不能となった場合 
⑥  本規約等に違反した場合
⑦  その他、弊社が必要があると判断した場合 
２  前項の措置に関して、弊社はユーザーその他第三者に対して一切責任を負わないものとします。`,

  "tos.art18.title": "第18条（損害賠償）",
  "tos.art18.content": `弊社は、本サービスの提供に際し、ユーザーの責に帰すべき事由により損害を被った場合、損害賠償を請求することができるものとします。
２  弊社は、本サービス利用により生じた一切の損害につき、その賠償義務を負いません。
３  弊社は、ユーザーその他の第三者に発生した機会逸失、業務の中断その他いかなる損害（間接損害や逸失利益を含みます。）に対して、係る損害の可能性を事前に通知されていたとしても、一切の責任を負いません。`,

  "tos.art19.title": "第19条（利用規約等の変更について）",
  "tos.art19.content":
    "弊社は、利用規約等を随時改定することがあります。利用規約等の改定後は、改定後の利用規約等を適用するものとします。なお、当該改定は、弊社がユーザーに対して本利用規約で定める通知した場合に効力が生じたものとみなします。",

  "tos.art20.title": "第20条（利用規約について）",
  "tos.art20.content":
    "本利用規約の一部の条項が無効とされた場合も、他の条項の効力には影響せず、他の規定は有効とします。",

  "tos.art21.title": "第21条（準拠法）",
  "tos.art21.content": "本規約の準拠法は日本法とします。",

  "tos.art22.title": "第22条（裁判管轄）",
  "tos.art22.content":
    "本規約に関連して弊社とユーザーとの間で生じた紛争については、弊社の所在地を管轄する裁判所を第一審の合意管轄裁判所とします。",

  "tos.date": "平成28年2月18日"
};

export const jaPrivacy: I18nMessages = {
  "privacy.title": "アプリケーション・プライバシーポリシー"
};
